// extracted by mini-css-extract-plugin
export var attachment = "_od-a";
export var emailContainer = "_od-4";
export var emailContentPaddedContainer = "_od-b";
export var emailHeader = "_od-6";
export var emailIframe = "_od-3";
export var emailInfoIcon = "_od-9";
export var emailShortenedSummary = "_od-e";
export var infoDropdown = "_od-0";
export var infoRowBoundedContent = "_od-d";
export var internal = "_od-5";
export var merchant = "_od-8";
export var messageInputContainer = "_od-h";
export var normal = "_od-7";
export var replyCard = "_od-f";
export var subtleButton = "_od-1";
export var subtleButtonIconContainer = "_od-2";
export var toggleViewRepliesButton = "_od-c";
export var wrappingText = "_od-g";